(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-paint-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-paint-gallery]');
    if (!root) return;
    const proxy = root.dataset.proxyRoot.replace(/\/$/, '');
    const status = root.querySelector('[data-gallery-status]');
    const grid = root.querySelector('[data-gallery-grid]');
    const template = document.querySelector('[data-gallery-card-template]');
    const dialog = document.querySelector('[data-gallery-dialog]');
    const message = root.querySelector('[data-gallery-form-message]');
    const form = root.querySelector('[data-gallery-form]');

    const showMessage = (target, text, error = false) => {
      target.textContent = text;
      target.setAttribute('aria-invalid', String(error));
    };

    const request = async (path, options) => {
      const response = await fetch(`${proxy}${path}`, options);
      const body = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(body.error || root.dataset.errorLabel);
      return body;
    };

    const loadGallery = async () => {
      try {
        const body = await request('/gallery');
        grid.replaceChildren();
        for (const submission of body.submissions) {
          const card = template.content.cloneNode(true);
          const image = card.querySelector('img');
          image.src = submission.image.url;
          image.alt = submission.image.alt;
          image.width = submission.image.width;
          image.height = submission.image.height;
          const product = card.querySelector('[data-gallery-product]');
          product.textContent = submission.product.title;
          product.href = submission.product.url;
          card.querySelector('[data-gallery-caption]').textContent = submission.caption;
          card.querySelector('[data-gallery-open]').addEventListener('click', () => {
            dialog.querySelector('img').src = submission.image.url;
            dialog.querySelector('img').alt = submission.image.alt;
            dialog.querySelector('h2').textContent = submission.product.title;
            dialog.querySelector('p').textContent = submission.caption;
            dialog.showModal();
          });
          grid.append(card);
        }
        showMessage(status, body.submissions.length ? '' : root.dataset.emptyLabel);
      } catch (error) { showMessage(status, error.message, true); }
    };

    const privacySafeImage = async (file) => {
      const bitmap = await createImageBitmap(file);
      const scale = Math.min(1, 2000 / Math.max(bitmap.width, bitmap.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(bitmap.width * scale));
      canvas.height = Math.max(1, Math.round(bitmap.height * scale));
      canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      bitmap.close();
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/webp', .88));
      if (!blob) throw new Error('This browser could not prepare the photo.');
      return new File([blob], 'painted-miniature.webp', { type: 'image/webp' });
    };

    if (form) {
      const select = form.querySelector('[data-gallery-products]');
      request('/products').then(({ products }) => {
        for (const product of products) {
          const option = document.createElement('option');
          option.value = product.id;
          option.textContent = product.title;
          select.append(option);
        }
      }).catch((error) => showMessage(message, error.message, true));
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        button.disabled = true;
        showMessage(message, root.dataset.preparingLabel);
        try {
          const fields = new FormData(form);
          fields.set('consent', form.elements.consent.checked ? 'true' : 'false');
          fields.set('image', await privacySafeImage(form.elements.image.files[0]));
          const body = await request('/submissions', { method: 'POST', body: fields });
          form.reset();
          showMessage(message, body.message);
        } catch (error) { showMessage(message, error.message, true); }
        finally { button.disabled = false; }
      });
    }
    dialog.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    loadGallery();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
